"use strict";
import { useEffect, useState, useRef } from "react";
export const useHighlightOnNewItems = (newItems, duration = 3e3) => {
  const [highlightedItems, setHighlightedItems] = useState([]);
  const timeoutsRef = useRef([]);
  useEffect(() => {
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
    newItems.forEach((item) => {
      if (!highlightedItems.includes(item)) {
        setHighlightedItems((prev) => [...prev, item]);
        const timeout = setTimeout(() => {
          setHighlightedItems((prev) => prev.filter((i) => i !== item));
        }, duration);
        timeoutsRef.current.push(timeout);
      }
    });
    return () => {
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current = [];
    };
  }, [newItems, duration]);
  return highlightedItems;
};
